import { useDashboardStore } from '@modules/dashboard/store/useDashboardStore';
import { LoadingButton } from '@mui/lab';
import { Stack, Typography } from '@mui/material';

export const FetchingDashboardUpdatesInfo = () => {
  const polling = useDashboardStore(({ visual }) => visual.isPolling);

  if (!polling) {
    return null;
  }

  return (
    <Stack direction="row" spacing={1}>
      <LoadingButton
        sx={{ minWidth: 0 }}
        loading={true}
        variant="text"
        disabled
      />
      <Typography variant="caption" color="text.disabled">
        Fetching latest updates...
      </Typography>
    </Stack>
  );
};
